import { gql, TypedDocumentNode } from '@apollo/client'
import {
  CarouselGroup,
  CarouselMainSlideResponse,
  CarouselMainSlideCreateInput,
  CarouselMainSlideUpdateInput,
  CarouselReorderInput,
} from '../type/carousel'

export const FindCarouselSlides: TypedDocumentNode<
  { carouselSlidesFind: CarouselMainSlideResponse[] },
  { group: CarouselGroup }
> = gql`
  query FindCarouselSlides($group: CarouselGroup!) {
    carouselSlidesFind(group: $group) {
      id
      group
      entityId
      title
      subtitle
      mainImage
      displayOrder
      subSlides {
        id
        sku
        productId
        title
        subtitle
        productImage
        displayOrder
        slug
      }
    }
  }
`

export const CreateCarouselSlide: TypedDocumentNode<
  { carouselSlideCreate: CarouselMainSlideResponse },
  { input: CarouselMainSlideCreateInput }
> = gql`
  mutation CreateCarouselSlide($input: CarouselMainSlideCreateInput!) {
    carouselSlideCreate(input: $input) {
      id
      group
      entityId
      title
      subtitle
      mainImage
      displayOrder
      subSlides {
        id
        sku
        productId
        title
        subtitle
        productImage
        displayOrder
      }
    }
  }
`

export const UpdateCarouselSlide: TypedDocumentNode<
  { carouselSlideUpdate: CarouselMainSlideResponse },
  { input: CarouselMainSlideUpdateInput }
> = gql`
  mutation UpdateCarouselSlide($input: CarouselMainSlideUpdateInput!) {
    carouselSlideUpdate(input: $input) {
      id
      group
      entityId
      title
      subtitle
      mainImage
      displayOrder
      subSlides {
        id
        sku
        productId
        title
        subtitle
        productImage
        displayOrder
      }
    }
  }
`

export const DeleteCarouselSlide: TypedDocumentNode<void, { id: number }> = gql`
  mutation DeleteCarouselSlide($id: Int!) {
    carouselSlideDelete(id: $id)
  }
`

export const ReorderCarouselSlides: TypedDocumentNode<
  void,
  { input: CarouselReorderInput[] }
> = gql`
  mutation ReorderCarouselSlides($input: [CarouselReorderInput!]!) {
    carouselSlideReorder(input: $input)
  }
`
